const showCorrectFlag = (languageName: string, languageIso: string) => {
    if (languageName === 'Afrikaans') {
        return 'za';
    }

    return languageIso;
};

export default showCorrectFlag;
